// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__vQQeI","file":"styles_file__1vX7-"};